<template>
  <div :class="['cn-container-outer',(parentDivHeight >=400 && parentDivHeight<=499) ? 'cn-400' : '',(parentDivHeight >=500 && parentDivHeight<=599) ? 'cn-500' : '']" :style="{'--cn-conatiner-bgcolor': widgetConfig.backgroundColor , '--cn-links-color': widgetConfig.linksColor}">
    <!--header-->
    <div class="cn_header" v-if="!widgetConfig.hideTitle">
      <div class="cn_header_title" >
        <h1>{{(!widgetConfig.isCustomTitle) ? widgetConfig.title : widgetConfig.customTitle}}</h1>
        <p v-if="!widgetConfig.isCustomTitle">{{widgetConfig.topics[0].topic}}</p>
      </div>
    </div>
    <!--Widget-->
    <div :class="['cn-container']" >
      <!--All Post-->
      <div class="cn-main-post-wrapper" v-if="items">
        <div class="cn-post-row">
            <item
              v-for="(item,index) in items"
              :id="item.id"
              :itemIndex="index+1"
              :ref="item.id"
              :key="item.id"
              :itemData="item"
              :parentDivHeight="parentDivHeight"
              :linkColor=widgetConfig.linksColor
              v-on:onItemReadMore="dispalyOverlay"
              v-on:shareItem="shareItem"
              :actionButton="widgetConfig.actionButton"
              :actionButtonText="widgetConfig.actionButtonText"
            ></item>

            <shimerloader v-if="loading"></shimerloader>

            <!--Load More-->
            <div class="">
              <div class="cn-loadmore-wrap" v-if="items.length && loadMore">
                <a rel="nofollow" href="javascript:void(0)" v-on:click="getItems('next')">Load More</a>
              </div>
            </div>

        </div>
      </div>
      <!--Overlay-->
      <itemOverlay
        v-if="showOverlay && overlayItemId"
        :items="items"
        :itemId="overlayItemId"
        v-on:closeOverlay="closeOverlay()"
        v-on:moveOverlay="moveOverlay"
        v-on:shareItem="shareItem"
      ></itemOverlay>

    </div>
    <!--widget footer-->
    <div class="cn_footer">
      <div class="cn_footer_logo">
        <a rel="nofollow" target="_blank" href="https://www.crowdynews.com">
          <i class="cn-icon-crowdynews cn-footer-icon"></i>
        </a>
      </div>
    </div>
    <!--widget footer end-->
  </div>
</template>

<script>
import item from './components/item'
import shimerloader from './components/shimerloader'
import itemOverlay from './components/item_overlay'
import axiox from 'axios'
export default {
  name: 'App',
  props: ['cnwidgetconf'],
  data () {
    return {
      items: [],
      showOverlay: false,
      overlayItemId: null,
      loading: true,
      loadMore: 0,
      API_URL: '',
      widgetConfig: '',
      project: '',
      widget: '',
      topic: '',
      TIME: new Date().getTime(),
      PROTOCOL: 'https:',
      SRC: '',
      blurTime: new Date().getTime(),
      inactiveTime: 0,
      widgetName: '',
      logGaInternal: false,
      logGaExternal: false,
      currentScreen: '',
      parentDivHeight: null
    }
  },
  components: {
    item: item,
    itemOverlay: itemOverlay,
    shimerloader: shimerloader
  },
  created () {
    this.widgetConfig = JSON.parse(this.cnwidgetconf)
    console.log(this.widgetConfig)
    this.API_URL = this.widgetConfig.topics[0].url
    this.topic = encodeURI(this.widgetConfig.topics[0].topic)
    this.slug = this.widgetConfig.topics[0].slug
    this.project = this.widgetConfig.project
    this.widget = this.widgetConfig.widget
    this.SRC =
      this.PROTOCOL +
      '//statistics.crowdynews.com/bb?d={d}&s={s}&a={a}&t={t}'
        .replace(/{d}/, this.project)
        .replace(/{s}/, this.widget)
    window.addEventListener('resize', this.resizeHandel)
  },
  mounted () {
    this.parentDivHeight = document.getElementsByTagName('cn-widget')[0].parentElement.parentElement.clientHeight
    this.getItems()
    this.$Lazyload.$on('error', function (el) {
      this.$refs[el.el.dataset.post_id].forEach(comp => {
        comp.mediaError()
      })
    }.bind(this))
    this.screenType(this.screenWidth())
  },
  methods: {
    getItems (next = false) {
      this.loading = true
      var reqUrl =
        this.API_URL +
        '&since=0&sort=time'
      reqUrl += '&count=' + ((this.widgetConfig.numPost) ? this.widgetConfig.numPost : 12)
      reqUrl += next ? '&offset=' + ((this.widgetConfig.numPost) ? this.widgetConfig.numPost : 12) * this.loadMore : ''
      axiox
        .get(reqUrl)
        .then(res => {
          if (res.data.lenght === 0) this.loadMore = false
          this.items.push(...res.data)
          // split data into columns
          this.loadMore++
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.loadMore = false
          console.error(err)
        })
    },
    getSecondsSpent (ms) {
      return ms < 0
        ? 0 // drop
        : ms < 1000
          ? 1 // less than 1 sec
          : ms < 5000
            ? 5 // less than 5 sec
            : ms < 10000
              ? 10 // less than 10 sec
              : ms < 15000
                ? 15 // less than 15 sec
                : ms < 20000
                  ? 20 // less than 20 sec
                  : ms < 25000
                    ? 25 // less than 20 sec
                    : ms < 30000
                      ? 30 // less than 30 sec
                      : ms < 40000
                        ? 40 // less than 40 sec
                        : ms < 50000
                          ? 50 // less than 50 sec
                          : ms < 60000
                            ? 60 // 30-60 sec
                            : ms < 120000
                              ? 120 // 1-2 min
                              : ms < 180000
                                ? 180 // 2-3 min
                                : ms < 240000
                                  ? 240 // 3-4 min
                                  : ms < 300000
                                    ? 300 // 4-5 min
                                    : ms < 900000
                                      ? 900 // 5-15 min
                                      : ms < 1800000
                                        ? 1800 // 15-30 min
                                        : ms < 3600000
                                          ? 3600 // 30-60 min
                                          : ms < 7200000
                                            ? 7200 // 1-2 hour
                                            : 0
    },
    isAnalytics (gaCode) {
      return /^ua-\d{4,9}-\d{1,4}$/i.test(gaCode.toString())
    },
    screenType (width) {
      var device = ''

      if (width > 1024) {
        device = 'desktop'
      } else if (width <= 1024 || width >= 768) {
        device = 'tablet'
      } else {
        device = 'mobile'
      }
      // var data = '&a=' + device + '&t=' + time
      // onResize again and again we will not sent the request
      if (this.currentScreen === '' || this.currentScreen !== device) {
        this.currentScreen = device
        this.track(
          'view',
          device,
          window.location.href,
          'both',
          'nonInteraction'
        )
        this.track(
          'widget type',
          device,
          'vertical',
          'ga',
          'nonInteraction'
        )
        this.track(
          'initial topic',
          '',
          null,
          'ga',
          'nonInteraction'
        )
        this.visibility()
      }
    },
    screenWidth () {
      var win = window
      var doc = document
      var docElem = doc.documentElement
      var body = doc.getElementsByTagName('body')[0]
      var width = win.innerWidth || docElem.clientWidth || body.clientWidth
      return width
    },
    track (type, id, eventLabel, statsTracker, fieldsObject) {
      var time = new Date().getTime()
      var gaFieldsObject = {}

      if (fieldsObject && fieldsObject === 'nonInteraction') {
        gaFieldsObject.nonInteraction = true
      }

      if (type === 'time') {
        var dt = time - this.TIME

        id = this.getSecondsSpent(dt)
      }

      var stat = id ? type + '_' + id : type
      var src = this.SRC.replace(/{a}/, stat).replace(/{t}/, time)

      // It should track the stats if the track event isn't ga specific.
      // All other cases should pass.
      if (statsTracker !== 'ga') {
        axiox.get(src)
      }

      // if (logGaExternal && (statsTracker === 'ga' || statsTracker === 'both')) {
      //   ga(
      //     'cnTracker.send',
      //     'event',
      //     'Crowdynews Widget' + ' ' + widgetName,
      //     type, eventLabel || id, gaFieldsObject
      //   );
      // }

      // if (logGaInternal && (statsTracker === 'ga' || statsTracker === 'both')) {
      //   ga(
      //     'cnInternalTracker.send',
      //     'event',
      //     'Crowdynews Widget' + ' ' + widgetName,
      //     type, eventLabel || id, gaFieldsObject
      //   );
      // }
    },
    visibility () {
      var wasVisible = false
      var scrolled = false
      var startTime = null

      var isVisible = function () {
        var container = document.querySelector('.cn-container')
        var windowSize = window.pageYOffset
        var pageSize = windowSize + window.innerHeight

        // Check for center instead of top & bottom
        var widgetLocation = container.offsetTop + container.offsetHeight / 2

        // Widget is visible
        var visible = windowSize < widgetLocation && widgetLocation < pageSize

        if (visible && !wasVisible) {
          // Set a start time.
          startTime = new Date().getTime()
        } else if (!visible && wasVisible) {
          // Set the end time.
          var endTime = new Date().getTime()

          // Check the time spent viewing the widget
          var secondsSpent =
            endTime - startTime - (this.inactiveTime > 0 ? this.inactiveTime : 0)
          var secondsSpentRounded = this.getSecondsSpent(parseInt(secondsSpent, 10))

          this.inactiveTime = 0

          // CHECK ME: Fire off the stats here
          this.track('visible', secondsSpentRounded, null, 'both')

          // Set things back to normal
          startTime = 0
          wasVisible = false
        }

        // Check if the widget was visible
        wasVisible = visible
      }.bind(this)

      window.addEventListener('scroll', function () {
        scrolled = true
      })

      setInterval(function () {
        if (scrolled) {
          isVisible()
          scrolled = false
        }
      }, 200)

      window.addEventListener('focus', function () {
        this.inactiveTime = new Date().getTime() - this.blurTime
      })

      window.addEventListener('blur', function () {
        this.blurTime = new Date().getTime()
      })
    },
    resizeHandel () {
      this.screenType(this.screenWidth())
    },
    dispalyOverlay (itemId) {
      var singleItem = ''
      singleItem = this.items.find((i) => i.id === itemId)
      // if Overlay true then open link if false then open model/popup
      if (this.widgetConfig.isOverlay) {
        // count click on readMore
        this.track('click-more', this.slug)
        // check google macro
        if (window.cn_global && window.cn_global.click_macro) {
          window.open(window.cn_global.click_macro + '' + singleItem.url, '_blank')
        } else {
          window.open(singleItem.url, '_blank')
        }
        return ''
      }
      this.track('details-' + singleItem.type, this.slug, singleItem.url, 'both')
      this.showOverlay = true
      this.overlayItemId = itemId
    },
    shareItem (e) {
      this.track('share-' + e, this.slug)
    },
    closeOverlay () {
      this.showOverlay = false
      this.overlayItemId = null
    },
    moveOverlay (e) {
      if (e) {
        this.track('overlay-' + e, null, null, 'both')
      }
    }
  }
}
</script>

<style scoped>
@import "./assets/style.css";
.cn-container {
    background-color: var(--cn-conatiner-bgcolor);
}
.cn_header_title h1 {
  color:  var(--cn-links-color) !important ;
}
.cn-footer-icon{
  color:  var(--cn-links-color) !important ;
}
>>> .cn-icon-crowdy{
  color:  var(--cn-links-color) !important ;
}
>>> .cn-post-block-inner-wrap  a {
  color:  var(--cn-links-color) !important ;
}
>>> .cn-post-footer-left a {
  color:  var(--cn-links-color) ;
}
>>> .cn-social-links li a {
  color: #b4b4b4 !important;
}
>>> .cn-social-links li a:hover {
  color:  var(--cn-links-color) !important ;
}
>>> .cn-popup-body a {
    color:  var(--cn-links-color) !important ;
}
.cn-loadmore-wrap a{
    background: var(--cn-links-color);
}
>>> .cn-share-popup ul li a:hover{
  color: var(--cn-links-color) !important;
}

>>> .buy-now{
  background-color: var(--cn-links-color) !important;
  color: #fff;
  border: 1px solid;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}

>>> .buy-now:hover{
  background-color: #fff !important;
  color: var(--cn-links-color) !important;
}

</style>
